export enum DiagnosisBatchActionType {
    PREFORMATTED = 'PREFORMATTED',
    TEXT_TEMPLATE = 'TEXT_TEMPLATE',
    SYNOPTIC_TEMPLATE = 'SYNOPTIC_TEMPLATE'
}

export enum DiagnosisBatchActionsApplyOption {
    TOTAL_REPLACE = 'totalReplace',
    PARTIAL_REPLACE = 'partialReplace',
    ADD = 'add'
}
